import formsoutline from "../../../../assets/images/docs/outline/forms.png";
import formsoutlinebad from "../../../../assets/images/docs/outline/forms-bad.png";
import forminspector from "../../../../assets/images/blogs/pp25/forminspector.png";
import formcta from "../../../../assets/images/formcta.png";
import wrongformoutline from "../../../../assets/images/blogs/forminspector/errorform.png";
import inspectorsummary from "../../../../assets/images/blogs/forminspector/summary.png";
import inspectorconfig from "../../../../assets/images/blogs/forminspector/config.png";
import inspectorfields from "../../../../assets/images/blogs/forminspector/fields.png";
import inspectorfieldset from "../../../../assets/images/blogs/forminspector/fieldset.png";
import inspectorbuttons from "../../../../assets/images/blogs/forminspector/buttons.png";
import * as React from 'react';
export default {
  formsoutline,
  formsoutlinebad,
  forminspector,
  formcta,
  wrongformoutline,
  inspectorsummary,
  inspectorconfig,
  inspectorfields,
  inspectorfieldset,
  inspectorbuttons,
  React
};